import { render, staticRenderFns } from "./AddProjectPage.vue?vue&type=template&id=226de749&"
import script from "./AddProjectPage.vue?vue&type=script&lang=js&"
export * from "./AddProjectPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports